import { useState, useCallback } from "react";
import { Heart } from "lucide-react";

export function LikeButton({ productId }: { productId: string }) {
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(0);

  const toggle = useCallback(() => {
    setLiked((prev) => {
      setCount((c) => (prev ? c - 1 : c + 1));
      return !prev;
    });
  }, []);

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        toggle();
      }}
      className="inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs transition-colors hover:bg-accent"
    >
      <Heart
        className={`h-3.5 w-3.5 ${liked ? "fill-red-500 text-red-500" : "text-muted-foreground"}`}
      />
      {count > 0 && <span className="text-muted-foreground">{count}</span>}
    </button>
  );
}
